// @ts-nocheck
/* eslint-disable */
export const checkIndeterminateSmallIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 13V11H17V13H7Z" fill="currentColor"/></svg>`,
    name: 'check-indeterminate-small' as const
};